<template>
  <div class="app-sim-card-order">
    <SimOrderWrapper :show-esim="showEsim" :loading="loading" :simtype.sync="simtype_" @next="activationCall">
      <template slot="txtBefore"><slot name="txtBefore"></slot></template>
      <template slot="txtAfter"><slot name="txtAfter"></slot></template>
    </SimOrderWrapper>
  </div>
</template>
<script>
import SimOrderWrapper from './SimOrderWrapper.vue'
import slotProxy from '../../../../../../mixins/slotProxy'
import { mapActions } from 'vuex'
import { SimTypes } from '@/helper/SimTypes'

export default {
  name: 'SimOrder',
  mixins: [slotProxy()],
  data() {
    return {
      simtype_: SimTypes.simCardCode,
      loading: false
    }
  },
  components: { SimOrderWrapper },
  methods: {
    ...mapActions('substituteSimCard', ['requestSubstituteSimCard']),
    activationCall(productNumber) {
      this.loading = true
      this.requestSubstituteSimCard({ productNumber: productNumber, simType: this.simtype_ })
      this.loading = false
      window.location.href = '/mein-lidl-connect/sim-karte-verwalten-v2.html'
    }
  },
  props: {
    showEsim: {
      type: Boolean,
      default: false
    }
  }
}
</script>
